<template>
  <div>
    <a-spin :spinning="loading">
        <a-tabs defaultActiveKey="1" size="large">
          <a-tab-pane key="1">
            <span slot="tab">
              <a-icon type="bank" />
              Bancos
            </span>
            <a-form-model layout="vertical" :model="infoCompleteEmpBank" :rules="formRules"
                          @submit.native.prevent @submit="guardarDatosEmpBank"
                          ref="dato_emp_bank">
            <a-card>
              <a-tabs defaultActiveKey="1"
                      size="small"
              >
                <a-tab-pane key="1">
                <span slot="tab">
                  <a-icon type="bank" />
                  Bancos
                </span>
                  <a-card>
                      <a-row :gutter="[16,16]" :md="12" :xs="24">
                        <a-col v-bind="colSpan">
                          <a-form-model-item :label="$t('Banco')" prop="id_bank" has-feedback>
                            <form-model-dropdown style="width: 100%"
                                                 endpoint="bank"
                                                 v-model="infoCompleteEmpBank.id_bank"
                                                 :customSlots="['suffixIcon']"
                            >
                            </form-model-dropdown>
                          </a-form-model-item>
                        </a-col>
                        <a-col v-bind="colSpan">
                          <a-form-model-item :label="$t('Estado')" prop="estatus" has-feedback>
                            <form-model-dropdown style="width: 100%"
                                                 endpoint="hierarchy_lookup"
                                                 v-model="infoCompleteEmpBank.estatus"
                                                 :customSlots="['suffixIcon']"
                                                 :params="status"
                            >
                            </form-model-dropdown>
                          </a-form-model-item>
                        </a-col>
                        <a-col v-bind="colSpan">
                          <a-form-model-item :label="$t('Tipo de cuenta')" prop="bank_type" has-feedback>
                            <form-model-dropdown style="width: 100%"
                                                 endpoint="hierarchy_lookup"
                                                 v-model="infoCompleteEmpBank.bank_type"
                                                 :customSlots="['suffixIcon']"
                                                 :params="tipo_cuenta"
                            >
                            </form-model-dropdown>
                          </a-form-model-item>
                        </a-col>
                        <a-col v-bind="colSpan">
                          <a-form-model-item :label="$t('Cuenta bancaria')" prop="bank_account" has-feedback>
                            <a-input style="width: 100%"
                                     v-model="infoCompleteEmpBank.bank_account"></a-input>
                          </a-form-model-item>
                        </a-col>
                        <a-col v-bind="colSpan">
                          <a-form-model-item :label="$t('Sucursal banco')" prop="bank_office">
                            <a-input style="width: 100%"
                                     v-model="infoCompleteEmpBank.bank_office"></a-input>
                          </a-form-model-item>
                        </a-col>
                      </a-row>
                  </a-card>
                </a-tab-pane>
                <a-tab-pane key="2">
                <span slot="tab">
                  <a-icon type="bank" />
                  Banco internacional
                </span>
                  <a-card>
                    <a-row :gutter="[16,16]" :md="12" :xs="24">
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Tipo banco beneficiario')" prop="id_h_tipobancobenef"
                                           has-feedback>
                          <form-model-dropdown style="width: 100%"
                                               endpoint="hierarchy_lookup"
                                               v-model="infoCompleteEmpBank.id_h_tipobancobenef"
                                               :customSlots="['suffixIcon']"
                                               :params="bancobenef"
                          >
                          </form-model-dropdown>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Código banco beneficiario')" prop="codigobancobeneficiario">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.codigobancobeneficiario"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Descripción banco beneficiario')"
                                           prop="descripcionbancobeneficiario">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.descripcionbancobeneficiario"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Tipo banco intermediario')" prop="id_h_tipobancointerm"
                                           has-feedback>
                          <form-model-dropdown style="width: 100%"
                                               endpoint="hierarchy_lookup"
                                               v-model="infoCompleteEmpBank.id_h_tipobancointerm"
                                               :customSlots="['suffixIcon']"
                                               :params="bancointerme"
                          >
                          </form-model-dropdown>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Número cuenta beneficiario')" prop="numerocuentabenef">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.numerocuentabenef"></a-input>
                        </a-form-model-item>
                      </a-col>

                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Código banco intermediario')" prop="codigobancointermediario">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.codigobancointermediario"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpanPagoDolares">
                        <a-form-model-item :label="$t('Pago en dólares')" prop="tienepagodolares">
                          <a-checkbox v-model="infoCompleteEmpBank.tienepagodolares">
                          </a-checkbox>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpanCodInstru">
                        <a-form-model-item :label="$t('Código instruccion 1')" prop="codigoinstruccion1">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.codigoinstruccion1"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpanCodInstru">
                        <a-form-model-item :label="$t('Texto instrucción 1')" prop="textoinstruccion1">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.textoinstruccion1"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpanCodInstru">
                        <a-form-model-item :label="$t('Código instruccion 2')" prop="codigoinstruccion2">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.codigoinstruccion2"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpanCodInstru">
                        <a-form-model-item :label="$t('Texto instrucción 2')" prop="textoinstruccion2">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.textoinstruccion2"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpanCodInstru">
                        <a-form-model-item :label="$t('Código instruccion 3')" prop="codigoinstruccion3">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.codigoinstruccion3"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpanCodInstru">
                        <a-form-model-item :label="$t('Texto instrucción 3')" prop="textoinstruccion3">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.textoinstruccion3"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpanCodInstru">
                        <a-form-model-item :label="$t('Código instruccion 4')" prop="codigoinstruccion4">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.codigoinstruccion4"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpanCodInstru">
                        <a-form-model-item :label="$t('Texto instrucción 4')" prop="textoinstruccion4">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.textoinstruccion4"></a-input>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-card>
                </a-tab-pane>
              <a-tab-pane key="3">
                <span slot="tab">
                  <a-icon type="build" />
                  Wire y ach
                </span>
                <a-card>
                    <a-row :gutter="[16,16]" :md="12" :xs="24">
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Banco intermediario')" prop="bancointermediariowire">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.bancointermediariowire"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Banco beneficiario')" prop="bancobeneficiariowire">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.bancobeneficiariowire"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('País banco intermediario')" prop="bancointerpaiswire">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.bancointerpaiswire"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('País banco beneficiario')" prop="bancobeneficiariopaiswire">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.bancobeneficiariopaiswire"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Ciudad banco intermediario')" prop="bancointerciudadwire">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.bancointerciudadwire"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Ciudad banco beneficiario')" prop="bancobeneficiariociudadwire">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.bancobeneficiariociudadwire"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Dirección banco intermediario')" prop="bancointerdireccionwire">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.bancointerdireccionwire"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Dirección banco beneficiario')"
                                           prop="bancobeneficiariodireccionwire">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.bancobeneficiariodireccionwire"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Banco beneficiario')" prop="bancobeneficiarioach">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.bancobeneficiarioach"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Banco intermediario')" prop="bancointermediarioach">
                          <a-input style="width: 100%"
                                   v-model="infoCompleteEmpBank.bancointermediarioach"></a-input>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-card>

                </a-tab-pane>
              </a-tabs>

            </a-card>
            <a-affix :offset-bottom="10">
              <a-card style="text-align: right" :bodyStyle="{padding: '12px 24px'}">
                <a-button v-if="!$userIsInrol('Query')" 
                  type="primary"
                  html-type="submit">
                  Guardar Cambios
                </a-button>
              </a-card>
            </a-affix>
            </a-form-model>
          </a-tab-pane>
          <a-tab-pane key="2">
            <span slot="tab">
              <a-icon type="clock-circle" />
              Histórico
            </span>
            <a-card>
              <employee-bank-hist ref="historial"
                                  :empleadoseleccionado="empleadoseleccionado"></employee-bank-hist>
            </a-card>
          </a-tab-pane>
        </a-tabs>
    </a-spin>
  </div>
</template>
<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        tipo_cuenta: {
          h_lookup_type: 'TIPO_CUENTA',
          use_code: true
        },
        status: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        bancobenef: {
          h_lookup_type: 'TIPO_BANCO_BENEF'
        },
        bancointerme: {
          h_lookup_type: 'TIPO_BANCO_INTERM'
        },
        isDeleteVisible: false,
        loading: false,
        infoCompleteEmpBank: {},
        formRules: {},
        colSpan: {
          xs: 24,
          md: 8
        },
        colSpanPagoDolares: {
          xs: 24,
          md: 24
        },
        colSpanCodInstru: {
          xs: 24,
          md: 12
        }
      }
    },
    methods: {
      guardarDatosEmpBank () {
        if (this.loading) return
        this.$refs.dato_emp_bank.validate(valid => {
          if (valid) {
            this.loading = true
            let request = {...this.infoCompleteEmpBank, id_emp: this.empleadoseleccionado}
            this.httpClient.getInstance().post('employee/guardar_datos_emp_bank', request)
              .then(() => {
                Mensajes.success('Correcto', 'Datos guardados correctamente')
                this.$refs.historial.consultarDatos()
              })
              .catch(() => {
              })
              .then(() => {
                this.loading = false
              })
          }
        })
      },
      consultarEmpBank () {
        this.loading = true
        let self = this
        this.httpClient.getInstance().get('employee/consultar_emp_bank/' + this.empleadoseleccionado)
          .then(response => {
            self.infoCompleteEmpBank = response.data
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar los datos')
          })
          .then(() => {
            this.selectedRowKeys = []
            this.loading = false
          })
      },
      initFormRules () {
        this.formRules = {
          id_bank: [{required: true, message: 'Valor requerido'}],
          estatus: [{required: false}],
          bank_type: [{required: true, message: 'Valor requerido'}],
          bank_account: [{required: true, message: 'Valor requerido'}],
          bank_office: [{required: false}],
          id_h_tipobancobenef: [{required: false}],
          codigobancobeneficiario: [{required: false}],
          descripcionbancobeneficiario: [{required: false}],
          id_h_tipobancointerm: [{required: false}],
          numerocuentabenef: [{required: false}],
          codigobancointermediario: [{required: false}],
          tienepagodolares: [{required: false}],
          codigoinstruccion1: [{required: false}],
          codigoinstruccion2: [{required: false}],
          codigoinstruccion3: [{required: false}],
          codigoinstruccion4: [{required: false}],
          textoinstruccion1: [{required: false}],
          textoinstruccion2: [{required: false}],
          textoinstruccion3: [{required: false}],
          textoinstruccion4: [{required: false}],
          bancointermediariowire: [{required: false}],
          bancobeneficiariowire: [{required: false}],
          bancointerpaiswire: [{required: false}],
          bancobeneficiariopaiswire: [{required: false}],
          bancointerciudadwire: [{required: false}],
          bancobeneficiariociudadwire: [{required: false}],
          bancointerdireccionwire: [{required: false}],
          bancobeneficiariodireccionwire: [{required: false}],
          bancobeneficiarioach: [{required: false}],
          bancointermediarioach: [{required: false}]
        }
      }
    },
    props: ['empleadoseleccionado'],
    watch: {
      empleadoseleccionado () {
        this.consultarEmpBank()
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.consultarEmpBank()
      this.initFormRules()
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeBank.vue